/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable-next-line import/no-extraneous-dependencies  */
'use client';
import { FC } from 'react';
import { styled } from '@linaria/react';
import { sendGTM, GTMEventKey, CustomEventName } from '@fe-cnyes/fe-common-gtm';

interface AccountProps {
  children: React.ReactElement | string;
  target?: '_self' | '_target';
  href?: string;
  height?: number | string;
  active?: boolean;
  gtmEvent?: {
    [GTMEventKey.EVENT_NAME]: CustomEventName;
    [GTMEventKey.SECTION]: string;
    [GTMEventKey.CLICK_ITEM]: string;
  }
}

const AccountButton = styled.a`
  cursor: pointer;
  text-decoration: none;
  background-color: white;
  text-align: center;
  font-size: 14px;
  border: 1px solid #e03f19;
  border-radius: 6px;
  color: #e03f19;
  white-space: nowrap;
  font-weight: normal;
  display: inline-block;
  line-height: 28px;
  padding: 0 6px;

  &:hover {
    background-color: rgba(224, 63, 25, 0.05);
  }
`;

const Account: FC<AccountProps> = ({ href, target, children, gtmEvent }) => {
  const onClick = () => {
    if(gtmEvent) {
      sendGTM(gtmEvent);
    }
  };
  return (
    <AccountButton href={href} onClick={onClick} target={target}>
      {children}
    </AccountButton>
  );
};

export default Account;
